import {Simplex as BaseSimplex} from 'services/sports/default/simplex';
import Const from 'constants';
import {getSimplexUnitName} from 'helpers/simplex-helper';
import Action from 'actions';
import RuleBuilder from 'services/simplex/rule-builder';
import {getLpService} from 'services/sports/factory';

export default class SimplexClassic extends BaseSimplex {
    multipositionFlexMaxExposure({incomingValues: {flexPositionsQuantity = 1}}) {
        const {
            sportConfig,
            playersData: {preparedPlayers},
        } = Action.getState();
        const configPositions = sportConfig.getConfigProp('positions', {});
        const playersGroupedByPositionName = preparedPlayers.groupedBy.property('positionName');
        const forbiddenFlexPositions = getLpService(sportConfig, {store: this.store}).exec(
            'getForbiddenFlexMaxExposurePositions',
            {flexPositionsQuantity},
        );

        function calcAtMost(positionNames) {
            let playersQuantity = 0;

            let posNumbers = [];
            positionNames.map((posName) => {
                const posObj = sportConfig.getPositionByName(posName);
                posNumbers = [...posNumbers, ...posObj.allowedPositions];
            });

            Object.values(configPositions).map((posObj) => {
                if (posObj.id === 'flex') {
                    return;
                }

                const duplicates = arrayDuplicates(posObj.allowedPositions, posNumbers);
                if (!isEmpty(duplicates)) {
                    return;
                }

                playersQuantity += posObj.minPlayers;
            });

            return sportConfig.getConfigProp('playersInTeam') - playersQuantity;
        }

        const positionsMap = {
            mixed: {},
            flex: {},
        };

        Object.values(configPositions).map((position) => {
            const positionNames = [];
            position.allowedPositions.map((key) => {
                positionNames.push(configPositions[key].shortName);
            });

            const mapPropName = position.id === 'flex' ? 'flex' : 'mixed';

            Object.keys(playersGroupedByPositionName).map((positionName) => {
                let duplicates = arrayDuplicates(positionNames, positionName.split('/'));

                if (isEmpty(duplicates)) {
                    return;
                }

                if (!positionsMap[mapPropName].hasOwnProperty(position.shortName)) {
                    positionsMap[mapPropName][position.shortName] = {};
                }
                if (!positionsMap[mapPropName][position.shortName].hasOwnProperty(positionName)) {
                    positionsMap[mapPropName][position.shortName][positionName] = {};
                }

                playersGroupedByPositionName[positionName].map((player) => {
                    positionsMap[mapPropName][position.shortName][positionName][getSimplexUnitName(player.playerId)] =
                        1;
                });
            });
        });

        const playersByPositions = {};
        Object.values(positionsMap.mixed).map((positions) => {
            Object.keys(positions).map((positionName) => {
                playersByPositions[positionName] = {...positions[positionName]};
            });
        });
        // console.log('playersByPositions',{...playersByPositions});
        const getRuleForMinUnitsQuantity = function (positionName, mixedPositions) {
            const result = [];

            const position = sportConfig.getPositionByName(positionName, {});

            if (isEmpty(position)) {
                return result;
            }

            const mixedPosition = mixedPositions[positionName];

            let keyPosVars = {};
            Object.values(mixedPosition).map((vars) => {
                keyPosVars = {...keyPosVars, ...vars};
            });

            if (isEmpty(keyPosVars)) {
                return result;
            }

            const keyPositionRule = {
                obj: position.minPlayers,
                type: Const.STACKS_NUMBER_TYPE_AT_LEAST,
                row: {...keyPosVars},
            };

            result.push(keyPositionRule);

            Object.keys(mixedPosition).map((mixedPosName) => {
                if (positionName === mixedPosName) {
                    return;
                }

                mixedPosName.split('/').map((subPosName) => {
                    if (positionName === subPosName || !mixedPositions.hasOwnProperty(subPosName)) {
                        return;
                    }

                    let posVars = {};
                    Object.values(mixedPositions[subPosName]).map((vars) => {
                        posVars = {...posVars, ...vars};
                    });

                    if (!isEmpty(posVars)) {
                        const position = sportConfig.getPositionByName(subPosName, {});

                        const ruleBuilder = RuleBuilder.fromAtLeast(position.minPlayers + keyPositionRule.obj);
                        ruleBuilder.addVars({...posVars, ...keyPositionRule.row});

                        result.push(ruleBuilder.createRule());
                    }
                });
            });

            {
                let poolOfPositions = [],
                    posVars = {},
                    minQuantity = 0;
                Object.keys(mixedPosition).map((mixedPosName) => {
                    mixedPosName.split('/').map((subPosName) => {
                        if (inArray(subPosName, poolOfPositions)) {
                            return;
                        }

                        poolOfPositions.push(subPosName);

                        const position = sportConfig.getPositionByName(subPosName, {});
                        minQuantity += position.minPlayers;

                        if (mixedPositions.hasOwnProperty(subPosName)) {
                            Object.values(mixedPositions[subPosName]).map((vars) => {
                                posVars = {...posVars, ...vars};
                            });
                        }
                    });
                });

                const ruleBuilder = RuleBuilder.fromAtLeast(minQuantity);
                ruleBuilder.addVars(posVars);

                result.push(ruleBuilder.createRule());
            }

            return result;
        };

        const getRuleForMaxUnitsQuantity = function (positionName, mixedPositions) {
            let result = [];

            const keyPositionNames = positionName.split('/');
            const mixedPosition = mixedPositions[positionName];
            let positionsStack = {};
            let allPlayerVars = {};

            Object.keys(mixedPosition).map((mixedPosName) => {
                let posPlayerVars = {...mixedPosition[mixedPosName]};

                allPlayerVars = {...allPlayerVars, ...posPlayerVars};

                const positions = arrayUnique([...mixedPosName.split('/'), ...keyPositionNames]);
                positions.map((pos) => (positionsStack[pos] = 1));

                Object.values(configPositions).map((position) => {
                    const {shortName} = position;

                    if (!inArray(shortName, positions)) {
                        return;
                    } else if (
                        !mixedPositions.hasOwnProperty(shortName) ||
                        !mixedPositions[shortName].hasOwnProperty(shortName)
                    ) {
                        return;
                    }

                    posPlayerVars = {
                        ...posPlayerVars,
                        ...mixedPositions[shortName][shortName],
                    };
                });
                // console.log('positions',[...positions])
                const playersQuantity = calcAtMost(positions);
                // console.log('playersQuantity',playersQuantity)
                if (0 < playersQuantity) {
                    const ruleBuilder = RuleBuilder.fromAtMost(playersQuantity);
                    ruleBuilder.addVars(posPlayerVars);

                    result.push(ruleBuilder.createRule());
                }
            });

            const positionNames = Object.keys(positionsStack);
            // console.log('positionNames',[...positionNames])
            let commonPlayersQuantity = calcAtMost(positionNames);
            // console.log('commonPlayersQuantity',commonPlayersQuantity)
            positionNames.map((positionName) => {
                if (
                    !mixedPositions.hasOwnProperty(positionName) ||
                    !mixedPositions[positionName].hasOwnProperty(positionName)
                ) {
                    return;
                }
                allPlayerVars = {
                    ...allPlayerVars,
                    ...mixedPositions[positionName][positionName],
                };
            });

            if (0 < commonPlayersQuantity) {
                const ruleBuilder = RuleBuilder.fromAtMost(commonPlayersQuantity);
                ruleBuilder.addVars(allPlayerVars);

                result.push(ruleBuilder.createRule());
            }

            return [...result];
        };

        const getRuleForMaxMixedUnitsQuantity = function (positionName, mixedPositions) {
            const mixedPosition = mixedPositions[positionName];
            const mixedPosNames = Object.keys(mixedPosition);
            let positionsStack = [];

            mixedPosNames.map((mixedPosName) => {
                positionsStack = [...positionsStack, ...mixedPosName.split('/')];
            });

            const commonPlayersQuantity = calcAtMost(positionsStack);

            let allPlayerVars = {};
            Object.keys(playersByPositions).map((playersPosName) => {
                const positions = playersPosName.split('/');
                for (let position of positions) {
                    if (!inArray(position, positionsStack)) {
                        return;
                    }
                }
                allPlayerVars = {...allPlayerVars, ...playersByPositions[playersPosName]};
            });

            const ruleBuilder = RuleBuilder.fromAtMost(commonPlayersQuantity);
            ruleBuilder.addVars(allPlayerVars);

            return [ruleBuilder.createRule()];
        };

        const getRuleForFlexPosition = function (flexPositions) {
            const result = [];

            const positionName = 'Flex';
            const position = sportConfig.getPositionByName(positionName, {});

            if (isEmpty(position)) {
                return result;
            }

            const forbiddenPositionNames = Object.keys(forbiddenFlexPositions);
            let keyPosVars = {};
            Object.keys(flexPositions[positionName]).map((key) => {
                const positionNames = key.split('/');
                const allowedPositions = arrayDiff(positionNames, forbiddenPositionNames);
                if (!isEmpty(allowedPositions)) {
                    keyPosVars = {...keyPosVars, ...flexPositions[positionName][key]};
                }
            });

            if (isEmpty(keyPosVars)) {
                return result;
            }

            let playersQuantity = position.minPlayers;
            forbiddenPositionNames.map((forbiddenPositionName) => {
                const position = sportConfig.getPositionByName(forbiddenPositionName, {});

                if (!isEmpty(position)) {
                    playersQuantity -= position.minPlayers;
                }
            });

            {
                const ruleBuilder = RuleBuilder.fromExactly(playersQuantity);
                ruleBuilder.addVars(keyPosVars);

                result.push(ruleBuilder.createRule());
            }

            return result;
        };

        let rules = [];
        Object.keys(positionsMap.mixed).map((positionName) => {
            const atLeast = getRuleForMinUnitsQuantity(positionName, positionsMap.mixed);

            rules = [...rules, ...atLeast];

            const atMost = getRuleForMaxUnitsQuantity(positionName, positionsMap.mixed);

            rules = [...rules, ...atMost];

            const mixedPositionsRules = getRuleForMaxMixedUnitsQuantity(positionName, positionsMap.mixed);

            rules = [...rules, ...mixedPositionsRules];
        });

        const flexRules = getRuleForFlexPosition(positionsMap.flex);

        rules = [...rules, ...flexRules];

        return [...rules];
    }

    max({incomingValues = {}}) {
        return super.max({
            incomingValues: {
                checkIfPlayerOnDoublePosition: true,
            },
        });
    }

    maxRandom({incomingValues = {}}) {
        return super.maxRandom({
            incomingValues: {
                checkIfPlayerOnDoublePosition: true,
            },
        });
    }

    playerPositionStacking({incomingValues = {}}) {
        const {
            playerPositionStacking: stacking,
        } = Action.getState();

        return this.exec('keyPlayerStacking', {
            ...incomingValues,
            isOverlapPrimaryAndSecondaryStacksAllowed: stacking.isOverlapPrimaryAndSecondaryStacksAllowed(),
        });
    }

    subjectToPermanent() {
        const constraints = {
            player: this.exec(
                'player',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            salary: this.exec(
                'salary',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            projectedOwnershipCap: this.exec(
                'projectedOwnership',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            projectedOwnershipForce: this.exec(
                'forceOfProjectedOwnership',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            teams: this.exec(
                'team',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            limitPositions: this.exec(
                'limitPositions',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            teamNameStacking: this.exec(
                'teamNameStacking',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            keyPlayerStacking: this.exec(
                'playerPositionStacking',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            passReceiver: this.exec(
                'passReceiver',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            projectionBoostRule: this.exec(
                'projectionBoostRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            bound: this.exec(
                'bound',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec(
                'playersWhoseGamesAreLocked',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            createdLineups: this.exec(
                'createdLineups',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            multiPositions: this.exec('multiPositions', {}, []),
            exposureMax: this.exec(
                'exposureMax',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            exposureMin: this.exec(
                'exposureMin',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            flexExposureMax: this.exec(
                'flexMaxExposure',
                {
                    unitIdPropName: 'uniqueId',
                },
                [],
            ),
            correlationStackingPrimaryRule: this.exec(
                'correlationStackingPrimaryRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            correlationStackingSecondaryRule: this.exec(
                'correlationStackingSecondaryRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            /** CorrelationStackingUniversalRule has to be set after primary rule. */
            correlationStackingUniversalRule: this.exec(
                'correlationStackingUniversalRule',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            correlationStackingRestrictedPlayers: this.exec(
                'correlationStackingRestrictedPlayers',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            keyPlayerStackingComboExpMax: this.exec(
                'keyPlayerStackingComboExpMax',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
            playerCombinationStacking: this.exec(
                'playerCombinationStacking',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                [],
            ),
        };

        return {...constraints};
    }
}
